import { render } from "./ShowRequisition.vue?vue&type=template&id=da6b5b1c"
import script from "./ShowRequisition.vue?vue&type=script&lang=js"
export * from "./ShowRequisition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__